import { action } from 'typesafe-actions'
import { PersonRole } from '@models/person-role'
import {RequestData} from "@models/axios";



export const enum PersonRolesActionTypes {
    FETCH_REQUEST = '@@personRoles/FETCH_REQUEST',
    FETCH_SUCCESS = '@@personRoles/FETCH_SUCCESS',
    FETCH_ERROR = '@@personRoles/FETCH_ERROR',

    DELETE_REQUEST = '@@personRoles/DELETE_REQUEST',
    DELETE_SUCCESS = '@@personRoles/DELETE_SUCCESS',
    DELETE_ERROR = '@@personRoles/DELETE_ERROR',

    CREATE_REQUEST = '@@personRoles/CREATE_REQUEST',
    CREATE_SUCCESS = '@@personRoles/CREATE_SUCCESS',
    CREATE_ERROR = '@@personRoles/CREATE_ERROR',

    UPDATE_REQUEST = '@@personRoles/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@personRoles/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@personRoles/UPDATE_ERROR'
}



export const fetchRequest = (data:RequestData) => action(PersonRolesActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: PersonRole[]) => action(PersonRolesActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(PersonRolesActionTypes.FETCH_ERROR, message);


export const deleteRequest = (data:RequestData) => action(PersonRolesActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data:RequestData) => action(PersonRolesActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(PersonRolesActionTypes.DELETE_ERROR, message);


export const createRequest = (data:RequestData) => action(PersonRolesActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data: PersonRole[]) => action(PersonRolesActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(PersonRolesActionTypes.CREATE_ERROR, message);


export const updateRequest = (data:RequestData) => action(PersonRolesActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: PersonRole[]) => action(PersonRolesActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(PersonRolesActionTypes.UPDATE_ERROR, message);